interface HeaderProps {
	onJoinWaitlist?: () => void;
}

export function Header({ onJoinWaitlist }: HeaderProps) {
	return (
		<div className="w-full h-12 sm:h-14 md:h-16 lg:h-[84px] absolute left-0 top-0 flex justify-center items-center z-20 px-6 sm:px-8 md:px-12 lg:px-0">
			{/* Horizontal divider line */}
			<div className="w-full h-0 absolute left-0 top-6 sm:top-7 md:top-8 lg:top-[42px] border-t border-[rgba(55,50,47,0.12)] shadow-[0px_1px_0px_white]"></div>

			{/* Navigation container */}
			<div className="w-full max-w-[calc(100%-32px)] sm:max-w-[calc(100%-48px)] md:max-w-[calc(100%-64px)] lg:max-w-[700px] lg:w-[700px] h-10 sm:h-11 md:h-12 py-1.5 sm:py-2 px-3 sm:px-4 md:px-4 pr-2 sm:pr-3 bg-[#F7F5F3] backdrop-blur-sm shadow-[0px_0px_0px_2px_white] overflow-hidden rounded-[50px] flex justify-between items-center relative z-30">
				{/* Logo */}
				<div className="flex justify-start items-center gap-2 sm:gap-3">
					<div className="flex flex-col justify-center text-[#2F3037] text-sm sm:text-base md:text-lg lg:text-xl font-medium leading-5 font-sans">
						Koach
					</div>
					<div className="flex flex-col justify-center text-[rgba(73,66,61,0.70)] text-[10px] sm:text-xs md:text-sm font-normal leading-4 font-sans">
						your running buddy who always knows
					</div>
				</div>

				{/* Login button */}
				<div className="hidden sm:flex h-6 sm:h-7 md:h-8 justify-start items-start gap-2 sm:gap-3">
					<button
						type="button"
						onClick={onJoinWaitlist}
						className="px-2 sm:px-3 md:px-[14px] py-1 sm:py-[6px] bg-white shadow-[0px_1px_2px_rgba(55,50,47,0.12)] overflow-hidden rounded-full flex justify-center items-center cursor-pointer hover:bg-[#F7F5F3] transition-colors"
					>
						<div className="flex flex-col justify-center text-[#37322F] text-xs md:text-[13px] font-medium leading-5 font-sans">
							Join the Waitlist
						</div>
					</button>
				</div>
			</div>
		</div>
	);
}
